import FormComponent from "./FormComponent";

function CreateTenderPage() {
  return (
    <div>
      <FormComponent />
    </div>
  );
}

export default CreateTenderPage;
